import Icon from "@mui/icons-material/ReceiptLongTwoTone";
import { YearlyNiyaazReceiptList } from "./YearlyNiyaazReceiptList";
import { YearlyNiyaazReceiptCreate } from "./YearlyNiyaazReceiptCreate";

export default {
  list: YearlyNiyaazReceiptList,
  create: YearlyNiyaazReceiptCreate,
  icon: Icon,
  label: "Yearly Niyaaz Receipts",
  options: { label: "Yearly Niyaaz Receipts" },
  name: "yearlyNiyaazReceipts",
};
